export default __webpack_public_path__ + "static/charles-headshot-a066c5d580ce6aceac9e8cec98eeb97a.png";